import {ExpandMore} from '@mui/icons-material';
import {AccordionDetails, AccordionSummary, Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

import {EMMAI_FORMS, EMMAI_FORMS as FORMS} from '../../../../../../../const';
import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import AddPractitionerButton from '../../../../shared/AddPractitionerButton/AddPractitionerButton';
import PractitionerToolbar from '../../../../shared/PractitionerToolbar/PractitionerToolbar/PractitionerToolbar';
import EmmaiPractitionerActivityInformationForm from '../../../EmmaiPractitionerActivityInformationForm/EmmaiPractitionerActivityInformationForm';
import EmmaiPractitionerForm from '../../../EmmaiPractitionerForm/EmmaiPractitionerForm';
import StyledAccordion from '../shared/StyledAccordion';
import StyledAccordionTitle from '../shared/StyledAccordionTitle';

const PractitionerActivityAccordion = ({expanded, onChange}) => {
  const {emmaiData, selectedPractitionerId, currentForm, hasPractitioners} = useEmmai();
  const shouldShowAdd = currentForm === EMMAI_FORMS.OFFICE_AND_PRACTITIONER_ACTIVITY && !hasPractitioners;

  return (
    <StyledAccordion expanded={expanded} onChange={onChange}>
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel2-content"
        id="panel2-header"
        sx={{
          '&.Mui-expanded .MuiAccordionSummary-content': {
            mb: 0.5
          }
        }}
      >
        <StyledAccordionTitle>Infos activité</StyledAccordionTitle>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          px: {
            xs: 0.5,
            sm: 1
          }
        }}
      >
        {hasPractitioners ? <PractitionerToolbar /> : null}

        {shouldShowAdd ? (
          <Grid container justifyContent="center">
            <AddPractitionerButton variant="form" />
          </Grid>
        ) : null}

        {currentForm === FORMS.OFFICE_AND_PRACTITIONER_ACTIVITY ? (
          <Box>
            {(emmaiData.practitioners || []).map(p => (
              <Box key={p.practitioner_id} sx={{display: p.practitioner_id === selectedPractitionerId ? 'block' : 'none'}}>
                <EmmaiPractitionerActivityInformationForm practitionerId={p.practitioner_id} />
              </Box>
            ))}
          </Box>
        ) : (
          <EmmaiPractitionerForm />
        )}
      </AccordionDetails>
    </StyledAccordion>
  );
};

PractitionerActivityAccordion.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default PractitionerActivityAccordion;
